import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VjsPlayerComponent } from './vjs-player/vjs-player.component';
import { SeriesPlayerComponent } from './vjs-player/series-player.component';

@NgModule({
  declarations: [VjsPlayerComponent,SeriesPlayerComponent],
  imports: [CommonModule],
  exports: [VjsPlayerComponent,SeriesPlayerComponent],
})
export class VjsModule {
  
}
